import { ROLES } from '@containers/Admin/shared/roles';
import {
  isAdminRole,
  isOfficeAdmin,
  isSupervisorOnly,
  isTargetUserAdmin,
  isBuScopedRole,
} from '@containers/Admin/shared/rolePermissions';

export const isRoleChangeForbiddenForSupervisor = ({
  currentUserRoles,
  selectedRole,
  selectedUser,
}) => {
  if (!isSupervisorOnly(currentUserRoles)) return false;
  const selectedRoleId = selectedRole && selectedRole.roleId;
  return isAdminRole(selectedRoleId) || isTargetUserAdmin(selectedUser);
};

export const getVisibleRolesForRoleManagement = ({ currentUserRoles, roles }) => {
  if (!isBuScopedRole(currentUserRoles)) return roles;
  const hiddenRoles = isOfficeAdmin(currentUserRoles)
    ? [ROLES.SUPERVISOR, ROLES.TECH_ADMIN, ROLES.MANAGEMENT_ADMIN]
    : [ROLES.TECH_ADMIN, ROLES.MANAGEMENT_ADMIN];
  return (roles || []).filter((role) => !hiddenRoles.includes(role.roleId));
};

export const getVisibleUsersForRoleManagement = ({ currentUserRoles, users }) => {
  if (!isBuScopedRole(currentUserRoles)) return users;
  return (users || []).filter((user) => {
    const userRoles = Array.isArray(user.roles) ? user.roles : [];
    const hasHiddenAdminRole = userRoles.includes(ROLES.TECH_ADMIN) || userRoles.includes(ROLES.MANAGEMENT_ADMIN);
    return !hasHiddenAdminRole;
  });
};
